import type { StoredAttribution } from './types';

const storageKey = 'getapet.attribution';
const cookieKey = 'gap_attribution';
const cookieMaxAgeSeconds = 60 * 60 * 24 * 90;

function writeCookie(value: StoredAttribution) {
  if (typeof document === 'undefined') return;

  const compact = {
    anonymous_id: value.anonymous_id,
    session_id: value.session_id,
    last_non_direct_touch: value.last_non_direct_touch
      ? {
          source: value.last_non_direct_touch.source,
          medium: value.last_non_direct_touch.medium,
          campaign: value.last_non_direct_touch.campaign,
          channel: value.last_non_direct_touch.channel,
          occurred_at: value.last_non_direct_touch.occurred_at,
        }
      : null,
  };

  document.cookie = `${cookieKey}=${encodeURIComponent(JSON.stringify(compact))}; Path=/; Max-Age=${cookieMaxAgeSeconds}; SameSite=Lax`;
}

export async function loadStoredAttribution(): Promise<StoredAttribution | null> {
  if (typeof localStorage === 'undefined') return null;

  const value = localStorage.getItem(storageKey);

  return value ? JSON.parse(value) : null;
}

export async function saveStoredAttribution(value: StoredAttribution): Promise<void> {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(storageKey, JSON.stringify(value));
  }

  writeCookie(value);
}
